import {
  Box,
  Button,
  Grid,
  Radio,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useAppStore } from "../../../appStore";
import * as yup from "yup";
import { useFormik } from "formik";
import axios from "axios";
import { useEffect } from "react";
import { api_url } from "../../../apiUtils";
import { toast } from "react-toastify";
import AccountBalanceWalletRoundedIcon from "@mui/icons-material/AccountBalanceWalletRounded";
import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useNavigate } from "react-router-dom";

function Withdraw() {
  const navigate = useNavigate();
  const {
    setWithdrawOpen,

    setUserDefaultBalance,
    maximumWithdrawAmount,
    setMaximumWithdrawAmount,
    minimumWithdrawAmount,
    setMinimunWithdrawAmount,
    minimumWalletBalance,
    setMinimumWalletBalance,
    setWalletBalance,
    walletBalance,
    setDepositSent,
    profileData,
  } = useAppStore();

  const setsnackbarMessage = useAppStore((state) => state.setSnackbarMessage);
  const setopenSnackbar = useAppStore((state) => state.setOpenSnackbar);
  const [points, setPoints] = useState(null);
  const [bankDetails, setBankDetails] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [walletType, setWalletType] = useState("main");
  const canUseAutoGameWallet = Boolean(profileData?.canUseAutoGameWallet);
  const selectedWalletBalance =
    walletType === "autoGame"
      ? Number(points?.autoGameBalance || 0)
      : Number(walletBalance || points?.balance || 0);
  const keepInWalletAmount = Number(minimumWalletBalance || 100);

  const validationSchema = yup.object({
    amount: yup
      .number()
      .required("Points is required")
      .test(
        "custom-test",
        `Points must be less than or equal to ${
          selectedWalletBalance - keepInWalletAmount
        }`,
        function (value) {
          // Add your custom validation logic here
          return value <= selectedWalletBalance - keepInWalletAmount;
        },
      )

      .min(
        Number(minimumWithdrawAmount),
        `Points must be greater than or equal to ${minimumWithdrawAmount}`,
      )
      .max(
        Number(maximumWithdrawAmount),
        `Points must be lesser than or equal to ${maximumWithdrawAmount}`,
      ),
  });

  const getBankDetails = async () => {
    let token = sessionStorage.getItem("accesstoken");
    try {
      const response = await axios.get(`${api_url}user/get-bank-details`, {
        headers: {
          accesstoken: token,
        },
      });
      let data = response.data;
      if (data.status === "success" && data.bankDetails) {
        setBankDetails(data.bankDetails); // Store bank details
      } else {
        setBankDetails(null); // No bank details available
      }
    } catch (error) {
      console.error("Failed to fetch bank details", error);
    }
  };

  const getWalletSettings = () => {
    let token = sessionStorage.getItem("accesstoken");
    let result = axios
      .get(`${api_url}wallet/get-common-wallet-settings`, {
        headers: {
          accesstoken: token,
        },
      })
      .then(function (response) {
        let data = response.data;
        console.log(data);
        if (data.status === "success") {
          setUserDefaultBalance(data.getWalletSettings[0].userDefaultBalance);
          setMaximumWithdrawAmount(
            data.getWalletSettings[0].maximumWithdrawAmount,
          );
          setMinimunWithdrawAmount(
            data.getWalletSettings[0].minimumWithdrawAmount,
          );
          setMinimumWalletBalance(
            +data.getWalletSettings[0].minimumWalletBalance,
          );
        }
      });
  };

  useEffect(() => {
    getWalletSettings();
    getBankDetails();
  }, []);

  useEffect(() => {
    if (!canUseAutoGameWallet && walletType !== "main") {
      setWalletType("main");
    }
  }, [canUseAutoGameWallet, walletType]);

  const formik = useFormik({
    initialValues: {
      amount: "",
    },
    validationSchema: validationSchema,

    onSubmit: async (values, { resetForm }) => {
      if (!bankDetails) {
        // If no bank details, show an error and prevent submission
        toast.error("Please add bank details to withdraw.");
        return;
      }

      if (isSubmitting) return; // Prevent multiple clicks

      setIsSubmitting(true); // Disable button after first click

      let updatedBalance = selectedWalletBalance - values.amount;
      if (walletType === "main") {
        setWalletBalance(updatedBalance);
      }
      setPoints((current) => ({
        ...(current || {}),
        [walletType === "autoGame" ? "autoGameBalance" : "balance"]:
          updatedBalance,
      }));

      try {
        let token = sessionStorage.getItem("accesstoken");
        const response = await axios.post(
          walletType === "autoGame"
            ? `${api_url}wallet/auto-game/withdraw`
            : `${api_url}wallet/withdraw`,
          values,
          {
            headers: {
              accesstoken: token,
            },
          },
        );
        let data = response.data;

        if (data.status === "success") {
          setDepositSent(true);
          toast.success("Request sent successfully");
          setWithdrawOpen(false);
          resetForm();
        }
      } catch (error) {
        if (walletType === "main") {
          setWalletBalance(selectedWalletBalance);
        }
        setPoints((current) => ({
          ...(current || {}),
          [walletType === "autoGame" ? "autoGameBalance" : "balance"]:
            selectedWalletBalance,
        }));
        toast.error(
          error?.response?.data?.message ||
            "An error occurred while sending the withdraw request",
        );
      } finally {
        setIsSubmitting(false);
      }
    },
  });
  // const handleAmountChange = (event) => {
  //   setResponseError("");
  //   const inputAmount = event.target.value;
  //   if (inputAmount === "") {
  //     formik.handleChange(event);
  //   } else {
  //     formik.setFieldValue("amount", inputAmount);
  //     // Check if the entered amount exceeds available points and set an error if needed
  //     if (inputAmount > maximumWithdrawAmount) {
  //       formik.setFieldError("amount", "error");
  //     } else if (inputAmount > (points ? points.balance : 0)) {
  //       formik.setFieldError("amount", "Amount exceeds available points");
  //     }
  //   }
  // };
  const handleAmountChange = (event) => {
    const inputAmount = event.target.value.replace(/\D/g, "");
    formik.setFieldValue("amount", inputAmount);
  };

  let tokenStr = sessionStorage.getItem("accesstoken");

  const getWalletPoints = async () => {
    const response = await axios.get(`${api_url}wallet/balance`, {
      headers: { accesstoken: tokenStr },
    });
    const request = response.data.walletPoint;

    setPoints(request);
    return response.data;
  };

  useEffect(() => {
    getWalletPoints();
  }, []);

  return (
    <Box
      sx={{
        maxHeight: { xs: "calc(100dvh - 56px)", sm: "calc(100vh - 108px)" },
        overflowY: "auto",
        pr: { xs: 0.25, sm: 0.75 },
        "&::-webkit-scrollbar": { width: 5 },
        "&::-webkit-scrollbar-thumb": {
          borderRadius: 4,
          backgroundColor: "#c4c8d6",
        },
      }}
    >
      <Box
        sx={{
          position: "relative",
          overflow: "hidden",
          p: { xs: 1.25, sm: 2.5 },
          borderRadius: { xs: 2, sm: 3 },
          color: "#fff",
          background: "linear-gradient(135deg, #171b4d 0%, #303b91 100%)",
          boxShadow: "0 12px 28px rgba(23, 27, 77, 0.22)",
          "&::after": {
            content: '""',
            position: "absolute",
            width: 120,
            height: 120,
            borderRadius: "50%",
            top: -65,
            right: -35,
            background: "rgba(105, 240, 174, 0.14)",
          },
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: { xs: 1, sm: 1.5 } }}>
          <Box
            sx={{
              width: { xs: 36, sm: 46 },
              height: { xs: 36, sm: 46 },
              flexShrink: 0,
              display: "grid",
              placeItems: "center",
              borderRadius: 2.25,
              color: "#171b4d",
              background: "#69f0ae",
            }}
          >
            <AccountBalanceWalletRoundedIcon sx={{ fontSize: { xs: 21, sm: 24 } }} />
          </Box>
          <Box>
            <Typography
              component="h2"
              sx={{
                fontSize: { xs: "1rem", sm: "1.4rem" },
                lineHeight: 1.2,
                fontWeight: 800,
              }}
            >
              Withdraw Points
            </Typography>
            <Typography
              sx={{
                mt: 0.2,
                color: "rgba(255,255,255,0.7)",
                fontSize: { xs: "0.68rem", sm: "0.78rem" },
              }}
            >
              Send a secure withdrawal request
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            position: "relative",
            display: "flex",
            alignItems: "center",
            gap: 1,
            mt: { xs: 1, sm: 2 },
            px: { xs: 0.8, sm: 1.25 },
            py: { xs: 0.6, sm: 0.9 },
            borderRadius: 2,
            background: "rgba(255,255,255,0.1)",
          }}
        >
          <AccessTimeRoundedIcon sx={{ color: "#69f0ae", fontSize: { xs: 17, sm: 20 } }} />
          <Typography sx={{ fontSize: { xs: "0.66rem", sm: "0.78rem" } }}>
            Withdrawal payments are processed daily at <strong>10:00 AM</strong>
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mt: { xs: 1.15, sm: 2 },
          p: { xs: 1.15, sm: 2 },
          borderRadius: { xs: 2, sm: 3 },
          color: "#fff",
          background: "linear-gradient(135deg, #168451, #20a968)",
          boxShadow: "0 8px 20px rgba(22,132,81,0.18)",
        }}
      >
        <Box>
          <Typography sx={{ fontSize: { xs: "0.64rem", sm: "0.72rem" }, opacity: 0.82 }}>
            Available wallet balance
          </Typography>
          <Typography sx={{ mt: 0.15, fontSize: { xs: "1.15rem", sm: "1.55rem" }, fontWeight: 900 }}>
            {Number(selectedWalletBalance || 0).toFixed(2)}
          </Typography>
        </Box>
        <AccountBalanceWalletRoundedIcon sx={{ fontSize: { xs: 27, sm: 34 }, opacity: 0.82 }} />
      </Box>

      {canUseAutoGameWallet && (
        <Box sx={{ mt: { xs: 1.25, sm: 2.25 } }}>
          <Typography
            sx={{
              mb: 0.75,
              color: "#171b4d",
              fontSize: { xs: "0.76rem", sm: "0.86rem" },
              fontWeight: 700,
            }}
          >
            Wallet
          </Typography>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
              gap: 1,
            }}
          >
            {[
              { label: "Main Wallet", value: "main" },
              { label: "Auto Game Wallet", value: "autoGame" },
            ].map((option) => {
              const selected = walletType === option.value;
              return (
                <Box
                  key={option.value}
                  role="radio"
                  aria-checked={selected}
                  tabIndex={0}
                  onClick={() => setWalletType(option.value)}
                  onKeyDown={(event) => {
                    if (event.key === "Enter" || event.key === " ") {
                      event.preventDefault();
                      setWalletType(option.value);
                    }
                  }}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.75,
                    minHeight: 46,
                    px: 1.25,
                    borderRadius: 2.25,
                    border: "1.5px solid",
                    borderColor: selected ? "#168451" : "#d9deea",
                    backgroundColor: selected ? "#effaf4" : "#f8f9fc",
                    color: "#171b4d",
                    cursor: "pointer",
                    transition: "all 160ms ease",
                  }}
                >
                  <Radio
                    checked={selected}
                    size="small"
                    value={option.value}
                    name="withdrawWalletType"
                    onChange={() => setWalletType(option.value)}
                    sx={{
                      p: 0,
                      color: "#8a92ad",
                      "&.Mui-checked": { color: "#168451" },
                    }}
                  />
                  <Typography sx={{ fontSize: "0.86rem", fontWeight: 700 }}>
                    {option.label}
                  </Typography>
                </Box>
              );
            })}
          </Box>
        </Box>
      )}

      <Typography
        sx={{
          mt: { xs: 1.25, sm: 2.25 },
          mb: { xs: 0.6, sm: 1 },
          color: "#171b4d",
          fontSize: { xs: "0.74rem", sm: "0.82rem" },
          fontWeight: 800,
        }}
      >
        Withdrawal limits
      </Typography>
      <Grid container spacing={1}>
        {[
          { label: "Minimum", value: minimumWithdrawAmount },
          { label: "Maximum", value: maximumWithdrawAmount },
          { label: "Keep in wallet", value: minimumWalletBalance },
        ].map((limit) => (
          <Grid item xs={4} key={limit.label}>
            <Box
              sx={{
                height: "100%",
                p: { xs: 0.65, sm: 1.25 },
                borderRadius: 2.25,
                border: "1px solid #e3e6ef",
                backgroundColor: "#f8f9fc",
                textAlign: "center",
              }}
            >
              <Typography
                sx={{
                  color: "#858b9d",
                  fontSize: { xs: "0.56rem", sm: "0.68rem" },
                  lineHeight: 1.25,
                }}
              >
                {limit.label}
              </Typography>
              <Typography
                sx={{
                  mt: { xs: 0.25, sm: 0.5 },
                  color: "#171b4d",
                  fontSize: { xs: "0.7rem", sm: "0.9rem" },
                  fontWeight: 800,
                }}
              >
                {limit.value ?? "—"}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>

      <Box sx={{ mt: { xs: 1.25, sm: 2.25 } }}>
        <Typography
          sx={{
            mb: 0.75,
            color: "#171b4d",
            fontSize: { xs: "0.76rem", sm: "0.86rem" },
            fontWeight: 700,
          }}
        >
          Points to withdraw
        </Typography>
        <TextField
          fullWidth
          id="amount"
          name="amount"
          type="tel"
          placeholder="Enter withdrawal points"
          inputProps={{
            inputMode: "numeric",
            pattern: "[0-9]*",
            enterKeyHint: "done",
          }}
          error={Boolean(formik.touched.amount && formik.errors.amount)}
          helperText={formik.touched.amount && formik.errors.amount}
          value={formik.values.amount}
          onChange={handleAmountChange}
          onBlur={formik.handleBlur}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: 2.5,
              backgroundColor: "#f8f9fc",
            },
            "& .MuiOutlinedInput-input": {
              py: { xs: 1.15, sm: 2 },
              px: { xs: 1.25, sm: 1.75 },
              fontSize: { xs: "0.82rem", sm: "1rem" },
            },
          }}
        />
      </Box>

      {!bankDetails && (
        <Box
          sx={{
            display: "flex",
            alignItems: { xs: "stretch", sm: "center" },
            flexDirection: { xs: "column", sm: "row" },
            gap: 1.25,
            mt: 1.5,
            p: 1.5,
            borderRadius: 2.5,
            color: "#8b461d",
            border: "1px solid #ffd6ad",
            backgroundColor: "#fff6ec",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
            <InfoOutlinedIcon sx={{ mt: 0.1, fontSize: 19 }} />
            <Box sx={{ flex: 1 }}>
              <Typography sx={{ fontSize: "0.78rem", fontWeight: 800 }}>
                Bank details not found
              </Typography>
              <Typography sx={{ mt: 0.2, fontSize: "0.7rem", lineHeight: 1.4 }}>
                Add your bank account before submitting a withdrawal request.
              </Typography>
            </Box>
          </Box>
          <Button
            variant="contained"
            size="small"
            onClick={() => {
              setWithdrawOpen(false);
              navigate("/profile?tab=1");
            }}
            sx={{
              flexShrink: 0,
              borderRadius: 2,
              color: "#fff",
              textTransform: "none",
              fontWeight: 700,
              backgroundColor: "#d66b28",
              boxShadow: "none",
              "&:hover": { backgroundColor: "#b9561d", boxShadow: "none" },
            }}
          >
            Add Bank Details
          </Button>
        </Box>
      )}

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: { xs: 0.75, sm: 1.25 },
          mt: { xs: 1.5, sm: 2.5 },
          pb: 0.25,
        }}
      >
        <Box sx={{ flex: "0 0 34%" }}>
          <Button
            fullWidth
            variant="outlined"
            color="error"
            onClick={() => setWithdrawOpen(false)}
            sx={{
              minHeight: { xs: 40, sm: 46 },
              borderRadius: 2.5,
              textTransform: "none",
              fontWeight: 700,
            }}
          >
            Cancel
          </Button>
        </Box>
        <Box sx={{ flex: 1 }}>
          <Button
            fullWidth
            variant="contained"
            onClick={formik.handleSubmit}
            disabled={isSubmitting}
            sx={{
              minHeight: { xs: 40, sm: 46 },
              borderRadius: 2.5,
              color: "#fff",
              textTransform: "none",
              fontWeight: 800,
              letterSpacing: 0.3,
              whiteSpace: "nowrap",
              fontSize: { xs: "0.7rem", sm: "0.875rem" },
              px: { xs: 0.75, sm: 2 },
              background: "linear-gradient(135deg, #171b4d, #303b91)",
              boxShadow: "0 8px 20px rgba(23,27,77,0.2)",
              "&:hover": {
                background: "linear-gradient(135deg, #11153d, #273177)",
              },
            }}
          >
            {isSubmitting ? "Requesting..." : "Submit Withdrawal Request"}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default Withdraw;
